import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import th from './locales/th.json';
import ru from './locales/ru.json';
import km from './locales/km.json';
import lo from './locales/lo.json';
import ms from './locales/ms.json';
import { detectInitialLang } from './detect';

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    th: { translation: th },
    ru: { translation: ru },
    km: { translation: km },
    lo: { translation: lo },
    ms: { translation: ms },
  },
  lng: detectInitialLang(),
  fallbackLng: 'en',
  returnEmptyString: false,
  interpolation: { escapeValue: false },
});

export default i18n;
